import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DocumentTxt = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DocumentTxt' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M2,12 L7,12 M4.5,12 L4.5,19 M16,12 L21,12 M18.5,12 L18.5,19 M14.5,11.5 L8.5,18.5 M8.5,11.5 L14.5,18.5' />
  </StyledIcon>
);
